export default __webpack_public_path__ + "static/media/volkswagen.162a7d33.png";